import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { enviroment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TermsService {
  constructor(private httpClient: HttpClient) {}

  async getTermsConditionUser(): Promise<any>  {
    return firstValueFrom<any>(
        this.httpClient.get<any>(enviroment.url + `termino`),
      );
  }

  async setTermsConditionUser(): Promise<any> {
    return firstValueFrom<any>(
        this.httpClient.post(enviroment.url + `termino`, null),
      );
  }
}